const state = {
  bannerDismissed: false,
  initialized: false
}

const getters = {
  showBanner: (state) => state.initialized && !state.bannerDismissed
}

const mutations = {
  SET_BANNER_DISMISSED(state, dismissed) {
    state.bannerDismissed = dismissed
  },
  SET_INITIALIZED(state) {
    state.initialized = true
  }
}

const actions = {
  loadDismissalState({ commit }) {
    try {
      const stored = localStorage.getItem('pg_cookie_notice_dismissed')
      if (stored) {
        const { dismissed } = JSON.parse(stored)
        commit('SET_BANNER_DISMISSED', dismissed)
      }
    } catch (e) {
      console.warn('Could not load cookie notice state:', e)
    }
    commit('SET_INITIALIZED')
  },

  dismissBanner({ commit }) {
    commit('SET_BANNER_DISMISSED', true)
    try {
      localStorage.setItem('pg_cookie_notice_dismissed', JSON.stringify({
        dismissed: true,
        timestamp: Date.now()
      }))
    } catch (e) {
      console.warn('Could not persist cookie notice dismissal:', e)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/cookie-notice/cookie-notice.module.js